import { render, staticRenderFns } from "./PremiumBreakdownModal.vue?vue&type=template&id=0b0f2e9a&scoped=true"
import script from "./PremiumBreakdownModal.vue?vue&type=script&lang=js"
export * from "./PremiumBreakdownModal.vue?vue&type=script&lang=js"
import style0 from "./PremiumBreakdownModal.vue?vue&type=style&index=0&id=0b0f2e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0f2e9a",
  null
  
)

export default component.exports